import React, { useState } from 'react';
import './EnrollmentModal.css';

interface EnrollmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  courseName: string;
}

const EnrollmentModal: React.FC<EnrollmentModalProps> = ({ isOpen, onClose, courseName }) => {
  const [formData, setFormData] = useState({
    program: courseName,
    name: '',
    email: '',
    phone: '',
    countryCode: '+91'
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Enrollment data:', formData);
    // You can add API call here
    alert('Thank you for your interest! We will contact you soon.');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-body">
          <div className="modal-left">
            <div className="stats-content">
              <h2 className="force-white-text" style={{ 
                color: '#ffffff', 
                fontWeight: '900',
                textShadow: 'none',
                opacity: '1',
                filter: 'none'
              }}>
                AI skills now required in <span 
                  className="force-white-text" 
                  style={{ 
                    color: '#ffffff', 
                    fontWeight: '900',
                    textShadow: 'none',
                    opacity: '1',
                    filter: 'none'
                  }}
                >1 in 3 tech jobs</span> - and demand is accelerating
              </h2>
              
              <p className="stats-description">
                Top companies like Amazon & Google need professionals 
                who combine <span className="text-highlight">strong fundamentals with AI fluency</span>
              </p>

              <div className="professional-image">
                <div className="image-placeholder">
                  <div className="avatar">👨‍💻</div>
                  <div className="decorative-icons">
                    <div className="icon icon-1">⭐</div>
                    <div className="icon icon-2">🚀</div>
                    <div className="icon icon-3">💡</div>
                    <div className="icon icon-4">⚡</div>
                  </div>
                </div>
                <p className="source-text">Source: Dice Tech Hiring Report</p>
              </div>
            </div>
          </div>

          <div className="modal-right">
            <div className="form-content">
              <h3>Get 1:1 Expert Guidance & <br />FREE Roadmap to stay ahead</h3>
              
              <form onSubmit={handleSubmit} className="enrollment-form">
                <div className="form-group">
                  <label>Your Topic of Interest*</label>
                  <select 
                    name="program" 
                    value={formData.program}
                    onChange={handleInputChange}
                    required
                  >
                    <option value={courseName}>{courseName}</option>
                    <option value="Agentic AI Engineering">Agentic AI Engineering</option>
                    <option value="Data Science with Python">Data Science with Python</option>
                    <option value="Prompt Engineering">Prompt Engineering</option>
                    <option value="AIOps & MLOps Engineering">AIOps & MLOps Engineering</option>
                    <option value="Data Engineering">Data Engineering</option>
                    <option value="BI Analytics & Reporting">BI Analytics & Reporting</option>
                  </select>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group phone-group">
                  <select 
                    name="countryCode" 
                    value={formData.countryCode}
                    onChange={handleInputChange}
                    className="country-code"
                  >
                    <option value="+91">+91</option>
                    <option value="+1">+1</option>
                    <option value="+44">+44</option>
                    <option value="+61">+61</option>
                  </select>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <button type="submit" className="continue-btn">
                  CONTINUE
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentModal;